import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import * as styles from './ImagePicker.scss';
import { Spinner } from 'components';
import { getRecentImages } from '../../redux/modules/imagePicker';
var ImagePickerSaved = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    recentImages: state.imagePicker.recentImages,
    organization: state.organization.current
  };
}, {
  getRecentImages: getRecentImages
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ImagePickerSaved, _Component);

  var _super = _createSuper(ImagePickerSaved);

  function ImagePickerSaved(props) {
    var _this;

    _classCallCheck(this, ImagePickerSaved);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getImages", function () {
      var loading = _this.state.loading;
      var _this$props = _this.props,
          organization = _this$props.organization,
          recentImages = _this$props.recentImages;

      _this.props.getRecentImages(organization.id);

      if (loading) {
        _this.setState({
          loading: true
        });

        return;
      }

      _this.setState({
        images: recentImages[_this.state.imageFilter]
      }); // TO-DO: figure out what this is for- it is currently not being used
      //const params = (() => {
      //   switch (this.state.imageFilter) {
      //     case 'user':
      //       return {
      //         mine: true
      //       };
      //     case 'team':
      //       return {
      //         fromTeamMembers: true
      //       };
      //     default:
      //       return {
      //         fromOrganization: parseInt(organization.id)
      //       };
      //   }
      // })();

    });

    _defineProperty(_assertThisInitialized(_this), "canViewTeamMembers", function () {
      var user = _this.props.user;

      if (user.isLikeableLocal) {
        return true;
      }

      if (user.isPartner) {
        return true;
      }

      return false;
    });

    _this.state = {
      images: [],
      searchValue: '',
      loading: false,
      hasMore: true,
      page: 1,
      imageFilter: 'org'
    };
    return _this;
  }

  _createClass(ImagePickerSaved, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getImages();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          images = _this$state.images,
          loading = _this$state.loading,
          hasMore = _this$state.hasMore;
      var _this$props2 = this.props,
          handleSelectImage = _this$props2.handleSelectImage,
          organization = _this$props2.organization,
          selectedImages = _this$props2.selectedImages,
          recentImages = _this$props2.recentImages;
      console.log(images);
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.pixabayWrapper,
        style: {
          height: 400
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          padding: 10
        }
      }, /*#__PURE__*/React.createElement("span", null, "View Images Used By:"), /*#__PURE__*/React.createElement(SelectField, {
        value: this.state.imageFilter,
        onChange: function onChange(e, index, val) {
          _this2.setState({
            imageFilter: val
          }, function () {
            return _this2.getImages();
          });
        },
        style: {
          marginLeft: 24
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: "org",
        primaryText: "".concat(organization.name)
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: "user",
        primaryText: "Me"
      }))), loading && /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative',
          marginLeft: 'auto',
          marginRight: 'auto',
          transform: 'translateY(30px)'
        }
      }), !loading && /*#__PURE__*/React.createElement("div", {
        className: styles.pixabayContentWrap,
        style: {
          borderTop: '1px solid rgb(224, 224, 224)'
        }
      }, images && images.length === 0 && !loading && /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'center'
        }
      }, "No images found"), images && images.length > 0 && images.map(function (image, index) {
        var _image$S3Files$;

        return /*#__PURE__*/React.createElement("div", {
          key: "savedimage_".concat(index),
          className: "".concat(styles.pixabayImage, " ").concat(_.some(selectedImages, image) ? styles.selectedPixabayImage : ''),
          style: {
            backgroundImage: "url(".concat((_image$S3Files$ = image.S3Files[0]) === null || _image$S3Files$ === void 0 ? void 0 : _image$S3Files$.fullyQualifiedUrl, ")")
          },
          onClick: function onClick() {
            handleSelectImage(image);
          }
        });
      }))));
    }
  }]);

  return ImagePickerSaved;
}(Component)) || _class);
export { ImagePickerSaved as default };
;
ImagePickerSaved.defaultProps = {
  imagePlaceholderColor: '#000000',
  loader: /*#__PURE__*/React.createElement("p", null, "Loading...")
};